import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { InputValidationMessage } from '@awaze/design-system.components.input';
import { findNestedError } from '@awaze/design-system.utils.form';
import { SelectContainerStyled, SelectStyled } from './select.styles';
/**
 * A basic select component.
 *
 * Use this alongside the `<InputControl>`,`<Label>`, `<InputDescription>` to create a fully featured form control.
 *
 * Use this in conjunction with the `useForm()` hook for easy handling of form state and validation.
 */
export const Select = React.forwardRef(({ formHooks, isDisabled = false, isRequired = false, name, options, placeholder = '', validation = {}, value = '', arrowColour, ...rest }, ref) => {
    const nameString = name;
    const { onChange, ...registerProps } = (formHooks && formHooks.register(nameString, validation)) || rest;
    const isNestedFormInput = formHooks && name.split('.').length > 1;
    const hasError = formHooks &&
        findNestedError(formHooks && formHooks.formState.errors, name.split('.'));
    const status = hasError ? 'error' : 'default';
    const errors = !isNestedFormInput
        ? formHooks && formHooks.formState.errors[name]
        : findNestedError(formHooks && formHooks.formState.errors, name.split('.'));
    // If using react-hook-form, we need to watch(name) - ie. re-render every time the value changes
    // to update placeholderActive
    formHooks?.watch(name);
    const placeholderActive = ((formHooks && !formHooks.getValues(name)) || (!formHooks && !value)) &&
        placeholder &&
        true;
    const optionsList = (items) => {
        return (Array.isArray(items.options) &&
            items.options.map((groupItem, i) => (_jsx("option", { value: groupItem.value, children: groupItem.text }, `${groupItem.value}-${i}`))));
    };
    return (_jsxs(SelectContainerStyled, { children: [_jsxs(SelectStyled, { disabled: isDisabled, id: name, name: name, placeholder: placeholder, ref: ref, required: isRequired, type: "select", value: value || undefined, placeholderActive: placeholderActive, arrowColour: arrowColour, status: status, ...rest, ...registerProps, onChange: (e) => {
                    onChange?.(e);
                }, validation: validation, children: [placeholder && (_jsx("option", { value: "", hidden: true, children: placeholder })), options.map((item) => item.label ? (_jsx("optgroup", { label: item.label, children: optionsList(item) }, `grp-${item.label}`)) : (optionsList(item)))] }), errors && (_jsx(InputValidationMessage, { status: "error", children: errors.message }))] }));
});
//# sourceMappingURL=select.js.map